import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { eventBus } from '@atc/cai-event-bus';

import { WALLET_CREATE_ID_COMPLETED } from 'wallet-manager';

export default function useWalletId({ paymentsDuck }) {
    const dispatch = useDispatch();

    function handleCreateWalletId(data = '') {
        if (data.length > 0) {
            dispatch(paymentsDuck.creators.setWalletId(data));
        }
    }

    useEffect(() => {
        eventBus.on(WALLET_CREATE_ID_COMPLETED, handleCreateWalletId);

        return () => {
            eventBus.off(WALLET_CREATE_ID_COMPLETED, handleCreateWalletId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
}
